<div id="team" class="team-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h4>Meet Addax</h4>
            <h2>Our Creative <span>Team</span></h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>
        <div class="team-slides">
            <owl-carousel-o [options]="teamSlides">
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/cars/audi.jpg" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">AUDI A6</h3>
                            <span class="post">1.9 TDI</span>
                        </div>
                        <div class="social">

                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/cars/audi.jpg" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">AUDI A5</h3>
                            <span class="post">3.0 TDI</span>
                        </div>
                        <div class="social">
                            <ul>
                                <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/cars/skoda.jpg" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">Skoda Octavia</h3>
                            <span class="post">2.0 TDI / Kombi</span>
                        </div>
                        <div class="social">
                            <ul>
                                <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/cars/skoda.jpg" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">Skoda Octavia</h3>
                            <span class="post">2.0 TDI / Kombi</span>
                        </div>
                        <div class="social">
                            <ul>
                                <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                                <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</div>
